import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GraphService } from 'src/app/shared/lib/api/graph.service';
import {
  GET_ALL_CLIENTS,
  GET_CLIENT_BY_ID,
  GET_CLIENT_BY_NAME,
} from '../graphql/clients.queries';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private graphService: GraphService) { }

  /**
   * @description Obtiene un cliente específico por su ID.
   * @param id El ID del cliente a obtener.
   * @returns Un Observable que emite la información del cliente obtenida desde el servidor GraphQL.
   */
  getById(id: String): Observable<any> {
    return this.graphService.queryGraphQLSales<any>({
      query: GET_CLIENT_BY_ID,
      variables: { id },
    });
  }

  /**
   * @description Obtiene un cliente específico por su nombre.
   * @param name El nombre del cliente a obtener.
   * @returns Un Observable que emite la información del cliente obtenida desde el servidor GraphQL.
   */
  getByName(name: String): Observable<any> {
    return this.graphService.queryGraphQLSales<any>({
      query: GET_CLIENT_BY_NAME,
      variables: { name },
    });
  }

  /**
   * @description Obtiene todos los clientes registrados en el sistema.
   * @returns Un Observable que emite la lista de clientes obtenida desde el servidor GraphQL.
   */
  getAll(): Observable<any> {
    return this.graphService.queryGraphQLSales<any>({
      query: GET_ALL_CLIENTS,
      variables: {},
    });
  }
}
